<!-- <IFA-header></IFA-header> -->

<main id="primary" class="site-main customMain">
  <section class="relative">
    <div class="content-panelMobile">
      <div class="container px-4 pt-5 mt-120">
        <div class="row d-flex">
          <div class="col-12">
            <div class="sb-tag sb-offerings mb-12">RISKS</div>
            <h2 class="wealth-section-title mb-6">
              What are the Risk Factors in Mutual Funds?
            </h2>
            <p class="wealth-section-description">
              Know the risks which comes with investments
            </p>
          </div>
        </div>

        <!-- mutual fund Accordian-->

        <div
          class="lg:w-full lg:max-w-full post-content pb-4 pt-8 lg:pt-6 sm:pt-4">
          <div class="wp-block-columns sec-ques-ans">
            <div class="wp-block-column" style="flex-basis: 30%">
              <div class="sidebar-block sticky pt-16">
                <div
                  id="lpwtoc_widget-3"
                  class="widget widget-sidebar widget_lpwtoc_widget">
                  <!--noindex-->
                  <div
                    class="lwptoc lwptoc-autoWidth lwptoc-inherit"
                    data-smooth-scroll="1"
                    data-smooth-scroll-offset="60"
                    data-lwptoc-initialized="1">
                    <div class="lwptoc_i">
                      <div class="lwptoc_header">
                        <b class="lwptoc_title bold UpperCase">
                          RISK IN MUTUAL FUNDS
                        </b>
                      </div>
                      <div
                        class="lwptoc_items1 lwptoc_items-visible"
                        style="font-size: 12pt">
                        <ol class="lwptoc_itemWrap">
                          <li class="lwptoc_item active">
                            <a href="#Tab1" data-toggle="tab" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Standard Risk Factors
                              </span>
                            </a>
                          </li>

                          <li class="lwptoc_item">
                            <a href="#Tab2" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Risk of losing money
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab3" rel="nofollow">
                              <span class="lwptoc_item_label">Price Risk</span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab4" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Liquidity Risk for listed securities
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab5" rel="nofollow">
                              <span class="lwptoc_item_label">Event Risk</span>
                            </a>
                          </li>

                          <li class="lwptoc_item">
                            <a href="#Tab6" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Interest Rate Risk
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab7" rel="nofollow">
                              <span class="lwptoc_item_label">Credit Risk</span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab8" rel="nofollow">
                              <span class="lwptoc_item_label">Spread Risk</span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab9" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Liquidity Risk
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab10" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Counterparty Risk
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab11" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Prepayment Risk
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab12" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Re-investment Risk
                              </span>
                            </a>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                  <!--/noindex-->
                </div>
              </div>
            </div>

            <div class="wp-block-column mt-120" style="flex-basis: 70%">
              <div
                class="answer-contents calculator_accordian desktop-disabled-acc"
                id="ques_ans_accordian">
                <div class="what-is-hra ans-card" id="Tab1">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab1_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Standard Risk Factors
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab1_ans">
                    <div class="main-panel">
                      <div>
                        <ul>
                          <li>
                            Mutual Fund Schemes are not guaranteed or assured
                            return products.
                          </li>
                          <li>
                            Investment in Mutual Fund Units involves investment
                            risks such as trading volumes, settlement risk,
                            liquidity risk, default risk including the possible
                            loss of principal.
                          </li>
                          <li>
                            As the price / value / interest rates of the
                            securities in which the Scheme invests fluctuates,
                            the value of investment in a mutual fund Scheme may
                            go up or down.
                          </li>
                          <li>
                            In addition to the factors that affect the value of
                            individual investments in the Scheme, the NAV of the
                            Scheme may fluctuate with movements in the broader
                            equity and bond markets and may be influenced by
                            factors affecting capital and money markets in
                            general, such as, but not limited to, changes in
                            interest rates, currency exchange rates, changes in
                            Government policies, taxation, political, economic
                            or other developments and increased volatility in
                            the stock and bond markets.
                          </li>
                          <li>
                            Past performance does not guarantee future
                            performance of any Mutual Fund Scheme.
                          </li>
                        </ul>

                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab2">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab2_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Risk of losing money
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab2_ans">
                    <div class="main-panel">
                      <div>
                        Investments in equity and equity related instruments
                        involve a degree of risk and investors should not invest
                        in the equity schemes unless they can afford to take the
                        risk of possible loss of principal.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab3">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab3_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Price Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab3_ans">
                    <div class="main-panel">
                      <div>
                        Equity shares and equity related instruments are
                        volatile and prone to price fluctuations on a daily
                        basis.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab4">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab4_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Liquidity Risk for listed securities
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab4_ans">
                    <div class="main-panel">
                      <div>
                        The liquidity of investments made in the equities may be
                        restricted by trading volumes and settlement periods.
                        Settlement periods may be extended significantly by
                        unforeseen circumstances. While securities that are
                        listed on the stock exchange carry lower liquidity risk,
                        the ability to sell these investments is limited by the
                        overall trading volume on the stock exchanges. The
                        inability of a mutual fund to sell securities held in
                        the portfolio could result in potential losses to the
                        scheme, should there be a subsequent decline in the
                        value of securities held in the scheme portfolio and may
                        thus lead to the fund incurring losses till the security
                        is finally sold.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab5">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab5_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Event Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab5_ans">
                    <div class="main-panel">
                      <div>
                        Price risk due to company or sector specific event.
                      </div>
                      <h2 style="text-transform: capitalize">
                        RISKS ASSOCIATED WITH INVESTMENT IN DEBT SECURITIES AND
                        MONEY MARKET INSTRUMENTS
                      </h2>
                      <div>
                        Debt Securities are subject to the risk of an issuer’s
                        inability to meet principal and interest payments on the
                        obligation (Credit Risk) on the due date(s) and may also
                        be subject to price volatility due to such factors as
                        interest rate sensitivity, market perception of the
                        creditworthiness of the issuer and general market
                        liquidity (Market Risk).
                      </div>
                      <div>
                        The timing of transactions in debt obligations, which
                        will often depend on the timing of the Purchases and
                        Redemptions in the Scheme, may result in capital
                        appreciation or depreciation because the value of debt
                        obligations generally varies inversely with the
                        prevailing interest rates.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab6">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab6_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Interest Rate Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab6_ans">
                    <div class="main-panel">
                      <div>
                        Market value of fixed income securities is generally
                        inversely related to interest rate movement. Generally,
                        when interest rates rise, prices of existing fixed
                        income securities fall and when interest rates drop,
                        such prices increase. Accordingly, value of a scheme
                        portfolio may fall if the market interest rate rise and
                        may appreciate when the market interest rate comes down.
                        The extent of fall or rise in the prices depends upon
                        the coupon and maturity of the security. It also depends
                        upon the yield level at which the security is being
                        traded.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab7">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab7_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Credit Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab7_ans">
                    <div class="main-panel">
                      <div>
                        This is risk associated with default on interest and /or
                        principal amounts by issuers of fixed income securities.
                        In case of a default, scheme may not fully receive the
                        due amounts and NAV of the scheme may fall to the extent
                        of default. Even when there is no default, the price of
                        a security may change with expected changes in the
                        credit rating of the issuer. It may be mentioned here
                        that a government security is a sovereign security and
                        is safer. Corporate bonds carry a higher amount of
                        credit risk than government securities. Within corporate
                        bonds also there are different levels of safety and a
                        bond rated higher by a rating agency is safer than a
                        bond rated lower by the same rating agency.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab8">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab8_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Spread Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab8_ans">
                    <div class="main-panel">
                      <div>
                        Credit spreads on corporate bonds may change with
                        varying market conditions. Market value of debt
                        securities in portfolio may depreciate if the credit
                        spreads widen and vice versa. Similarly, in case of
                        floating rate securities, if the spreads over the
                        benchmark security / index widen, then the value of such
                        securities may depreciate.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab9">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab9_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Liquidity Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab9_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          Liquidity risk refers to the ease with which
                          securities can be sold at or near its valuation
                          yield-to-maturity (YTM) or true value. Liquidity
                          condition in market varies from time to time. The
                          liquidity of a bond may change, depending on market
                          conditions leading to changes in the liquidity premium
                          attached to the price of the bond. In an environment
                          of tight liquidity, necessity to sell securities may
                          have higher than usual impact cost. Further, liquidity
                          of any particular security in portfolio may lessen
                          depending on market condition, requiring higher
                          discount at the time of selling.
                        </p>

                        <p>
                          The primary measure of liquidity risk is the spread
                          between the bid price and the offer price quoted by a
                          dealer. Trading volumes, settlement periods and
                          transfer procedures may restrict the liquidity of some
                          of these investments. Different segments of the Indian
                          financial markets have different settlement periods,
                          and such periods may be extended significantly by
                          unforeseen circumstances. Further, delays in
                          settlement could result in temporary periods when a
                          portion of the assets of the Scheme are not invested
                          and no return is earned thereon or the Scheme may miss
                          attractive investment opportunities.
                        </p>

                        <p>
                          At the time of selling the security, the security may
                          become illiquid, leading to loss in value of the
                          portfolio. The purchase price and subsequent valuation
                          of restricted and illiquid securities may reflect a
                          discount, which may be significant, from the market
                          price of comparable securities for which a liquid
                          market exists.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab10">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab10_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Counterparty Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab10_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          This is the risk of failure of the counterparty to a
                          transaction to deliver securities against
                          consideration received or to pay consideration against
                          securities delivered, in full or in part or as per the
                          agreed specification. There could be losses to the
                          fund in case of a counterparty default.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab11">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab11_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Prepayment Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab11_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          This arises when the borrower pays off the loan sooner
                          than the due date. This may result in a change in the
                          yield and tenor for the mutual fund scheme. When
                          interest rates decline, borrowers tend to pay off high
                          interest loans with money borrowed at a lower interest
                          rate, which shortens the average maturity of
                          Asset-backed securities (ABS). However, there is some
                          prepayment risk even if interest rates rise, such as
                          when an owner pays off a mortgage when the house is
                          sold or an auto loan is paid off when the car is sold.
                          Since prepayment risk increases when interest rates
                          decline, this also introduces reinvestment risk, which
                          is the risk that the principal may only be reinvested
                          at a lower rate.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab12">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab12_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Re-investment Risk
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab12_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          Investments in fixed income securities carry
                          re-investment risk as the interest rates prevailing on
                          the coupon payment or maturity dates may differ from
                          the original coupon of the bond (the purchase yield of
                          the security). This may result in final realized yield
                          to be lower than that expected at the time
                        </p>
                        <p>
                          The additional income from reinvestment is the
                          "interest on interest" component. There may be a risk
                          that the rate at which interim cash flows can be
                          reinvested are lower than that originally assumed.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End-->
      </div>
    </div>
  </section>
  <section class="grid-layout-common">
    <div class="container">
      <div class="col-md-12 col-xs-12 col-sm-12 nopadding">
        <div class="product-card-grid hover-animation" data-grid-size="8">
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Mutual-Fund"
            target="_self">
            <span>
              Mutual Funds -
              <br />
              <span class="no-wrap-text">Introduction & More</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Types_Of_MF"
            target="_self">
            <span>
              Various types
              <br />
              <span class="no-wrap-text">of Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/SIP"
            target="_self">
            <span>
              Systematic
              <br />
              <span class="no-wrap-text">Investment Plan?</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Advantages_Of_MutualFundsComponent"
            target="_self">
            <span>
              Advantages of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/categorization-of-mutual-funds"
            target="_self">
            <span>
              Categorisation of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card active"
            href="mf/risks-in-mutual-funds"
            target="_self">
            <span>
              Risk Factors in
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#Myth"
            target="_self">
            <span>
              Myths & Facts
              <br />
              <span class="no-wrap-text">about Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#FAQ"
            target="_self">
            <span>
              What is NAV?
              <br />
              <span class="no-wrap-text">& Other FAQs</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-ebe318f3-49dd-4b4f-9c3a-0cb8514a69fd"
            class="card link-plain featured customCard"
            (click)="modalPopOpen()"
            target="_self">
            <p
              style="
                font-size: 19px;
                color: #000;
                font-weight: bold;
                margin-bottom: 0px;
              ">
              Schedule a Call back
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- lets talk of model -->

  <div
    aria-hidden="true"
    aria-labelledby="LetsTalk_popup"
    class="modal fade"
    data-keyboard="false"
    id="LetsTalk_popup"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered border-0">
      <div class="modal-content border-0 p-0">
        <div class="modal-header border-0 p-0 ltmodalheader">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body border-0 p-10 pt-0 mobilep-2">
          <form>
            <div
              class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">
              <div class="align-self-center">
                <h2
                  class="wealth-section-title mb-8 mobilemb-5 mobilemt-0 fcwelth">
                  Let's Talk
                </h2>

                <p
                  class="wealth-section-description mb-12 mt-10 mobilemt-0 mobilemb-10">
                  Let's connect on a quick call to understand better.
                </p>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12 mt-10 mobilemt-0">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Full Name"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                    <div class="call-plan-form-group call-plan-form-group-name">

                      <input class="form-control" id="customer_name" placeholder="last name"
                        maxlength="30" name="customer-name" required="" type="text">
                      <label for="customer-name"></label>
                      <span class="d-none customer-name-error" style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div> -->
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Mobile"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      placeholder="Email"
                      maxlength="30"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <!-- <select class="form-control">
                      <option>State</option>
                    </select> -->
                    <input
                      class="form-control"
                      id="Statein"
                      placeholder="State"
                      maxlength="30"
                      name="Statein"
                      required=""
                      type="text" />
                    <label for="Statein"></label>
                    <span class="d-none Statein-error" style="color: red">
                      Please enter state
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="City"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Message"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="call-plan-form-group">
                    <label class="form-label">Preferred time to talk:</label>
                  </div>
                  <div
                    class="btn-group btn-group-toggle select-call-time select-call-time-js"
                    data-toggle="buttons">
                    <label class="btn btn-outline-sb-green option-1 active">
                      <input
                        data-max="12"
                        data-min="8"
                        id="option1"
                        name="schedule_time"
                        type="radio"
                        value="morning" />

                      10 - 12
                    </label>
                    <label class="btn btn-outline-sb-green option-2">
                      <input
                        data-max="16"
                        data-min="12"
                        id="option2"
                        name="schedule_time"
                        type="radio"
                        value="afternoon" />

                      12 - 2
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      2 - 4
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      4 - 6
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      6 - 8
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-20">
                  <div
                    class="call-plan-form-group text-center mt-30 mobilemt-0 mobilemb-0">
                    <div
                      class="mt-3 sb-primary-cta-button large-btn schedule-a-call trigger-event schedule-a-call-js"
                      data-action="schedule a call-Plan"
                      data-category="offering-Plan"
                      data-label="planning section">
                      Call Me
                    </div>
                    <a
                      href="mf/MobileMutualFund"
                      style="font-size: 10px"
                      target="_self"
                      class="anchorColor desktopHide">
                      Click here to know more about Mutual Funds first
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>

<IFA-footer></IFA-footer>
